import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant,{ Lazyload } from "vant";
import "vant/lib/index.css";

createApp(App).use(router).use(store).use(Vant).use(Lazyload).mount("#app");
